define('glu/dialog',['require','./$','./util','./locale','./core/modal/modalView','./core/modal/notificationView','jui/core'],function(require) {
    'use strict';

    var $ = require('./$'),
        util = require('./util'),
        locale = require('./locale'),
        ModalView = require('./core/modal/modalView'),
        NotificationView = require('./core/modal/notificationView');

    require('jui/core');

    function bindDialogButtons(view) {
        if (!view.dialogButtons) {
            return [];
        }

        return util.map(util.result(view, 'dialogButtons'), function(button) {
            var ret = util.extend({}, button);
            if (button.callback && util.isFunction(button.callback)) {
                ret.callback = util.bind(button.callback, view);
            } else if (button.callback && util.isString(button.callback) && util.isFunction(view[button.callback])) {
                ret.callback = util.bind(view[button.callback], view);
            }
            return ret;
        });
    }


    return {
        ModalView: ModalView, // Deprecated. 
        notifications: [],
        modals: [],
        notificationTopOffset: 15,
        notificationSpacing: 10,
        activeModal: false,
        //null doesn't handle it, so they clobber eachother, 
        //'replace' will close the current one.
        //stack waits for the active one to close to show the new one
        collisionMode: null,

        showPopup: function(view) {
            if (util.isFunction(view.determineFocus)) {
                this.viewPopup(view);
            } else {
                this.bootstrapPopup(view);
            }
        },
        /**
         * Uses an instance of a ModalView to enable modal functionality.
         */
        viewPopup: function(view) {
            if (this.activeModal && this.collisionMode === 'queue') {
                this.modals.push(view);
            } else if (this.activeModal && this.collisionMode === 'replace') {
                this.activeModal.close();
                this.renderModal(view);
            } else if (this.activeModal && this.collisionMode === 'stack') {
                this.modals.push(this.activeModal);
                this.renderModal(view);
            } else {
                this.renderModal(view);
            }

            return;
        },

        renderModal: function(view) {
            view.collisionMode = this.collisionMode;
            view.render();
            view.on('close', util.bind(this.handleCleanup, this, view));
            this.activeModal = view;
        },

        /**
         * Use bootstrap's jQuery plugin to push a view's element through
         * the plugin to enable modal functionality.
         */
        bootstrapPopup: function(view) {
            var $el = view.render().$el,
                self = this;

            $el.modal('show')
                .on('hidden', view.close);

            view.on('close', function() {
                $el.modal('hide').remove();
            });

            view.on('close', util.bind(this.handleCleanup, this, view));

            view.on('show', function() {
                self.determineFocus($el);
            });

            //ensure we always close the view if the modal is hidden to avoid orphaned views
            view.$el.on('hide.bs.modal', function() {
                view.close();
            });

            $('body').append($el);

            $el.on('keydown keypress', util.bind(this.handleKeydown, this, $el));

            //enables onShow in views for functionality that needs to happen after DOM insertion
            view.triggerMethod('show');

            // Keep a reference to the modal so that it can be closed via `dialog.close()`
            this.activeModal = view;
        },

        handleCleanup: function(view) {
            if (view === this.activeModal) {
                this.activeModal = false;
            }

            if (this.collisionMode === 'queue' && this.modals.length > 0) {
                this.showPopup(this.modals.shift());
            } else if (this.collisionMode === 'stack' && this.modals.length > 0) {
                this.activeModal = this.modals.pop();
            }

        },

        determineFocus: function($el) {
            var $tabbables = this.getTabbables($el);
            if ($tabbables.length > 0) {
                $tabbables.eq(0).focus();
            } else {
                $el.find('.glu-dialog').focus();
            }
        },

        getTabbables: function($el) {
            return ModalView.prototype.getTabbables.apply(this, arguments);
        },

        handleKeydown: function($el, e) {
            ModalView.prototype.handleKeyPress.apply(this, arguments);
        },

        alert: function(message, title, callback) {
            if (typeof title === 'function') {
                callback = title;
                title = null;
            }

            var popup = new ModalView({
                type: 'alert',
                message: message,
                title: title,
                buttons: [{
                    text: locale.get('ok'),
                    className: 'btn-primary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback();
                        }
                    }
                }]
            });

            popup.$el.attr('role', 'alertdialog');
            this.showPopup(popup);

            return popup;
        },

        confirm: function(message, title, callback) {
            if (typeof title === 'function') {
                callback = title;
                title = null;
            }

            if (typeof title !== 'function' && title === null) {
                title = ' ';
            }

            var popup = new ModalView({
                type: 'confirm',
                message: message,
                title: title,
                buttons: [{
                    text: locale.get('yes'),
                    className: 'btn-primary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback(true);
                        }
                    }
                }, {
                    text: locale.get('no'),
                    className: 'btn-tertiary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback(false);
                        }
                    }
                }]
            });

            popup.$el.attr('role', 'alertdialog');
            this.showPopup(popup);

            return popup;
        },

        error: function(message, title, callback) {
            if (typeof title === 'function') {
                callback = title;
                title = null;
            }

            var popup = new ModalView({
                type: 'error',
                message: message,
                title: title,
                icon: 'warning',
                buttons: [{
                    text: locale.get('ok'),
                    className: 'btn-primary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback();
                        }
                    }
                }]
            });

            popup.$el.attr('role', 'alertdialog');
            this.showPopup(popup);

            return popup;
        },

        warning: function(message, title, callback) {
            if (typeof title === 'function') {
                callback = title;
                title = null;
            }

            var popup = new ModalView({
                type: 'warning',
                message: message,
                title: title,
                icon: 'exclamation-solid',
                buttons: [{
                    text: locale.get('ok'),
                    className: 'btn-primary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback();
                        }
                    }
                }]
            });

            popup.$el.attr('role', 'alertdialog');
            this.showPopup(popup);

            return popup;
        },

        info: function(message, title, callback) {
            if (typeof title === 'function') {
                callback = title;
                title = null;
            }

            var popup = new ModalView({
                type: 'info',
                message: message,
                title: title,
                icon: 'exclamation-solid',
                buttons: [{
                    text: locale.get('ok'),
                    className: 'btn-primary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback();
                        }
                    }
                }]
            });

            popup.$el.attr('role', 'alertdialog');
            this.showPopup(popup);

            return popup;
        },

        success: function(message, title, callback) {
            if (typeof title === 'function') {
                callback = title;
                title = null;
            }

            var popup = new ModalView({
                type: 'success',
                message: message,
                title: title,
                icon: 'tick',
                buttons: [{
                    text: locale.get('ok'),
                    className: 'btn-primary',
                    callback: function() {
                        this.close();

                        if (callback) {
                            callback();
                        }
                    }
                }]
            });

            popup.$el.attr('role', 'alertdialog');
            this.showPopup(popup);

            return popup;
        },

        /**
         * Open a dialog using the specified view and optional overrides.
         *
         * NOTE: the second argument of this method has been repurposed as an options array.  Legacy
         * callers use the second argument as the dialog title.
         */
        open: function(view, options, buttons, icon, modalClass) {
            // first things first, try to derive dialog options from the view itself.
            var dialogOptions = this.getDialogOptions(view);

            // next, use the function arguments to override anything that was not supplied by the view.
            if (util.isObject(options)) {
                util.defaults(dialogOptions, options);
                this.$dialogTrigger = options.trigger || null;
            } else {
                util.defaults(dialogOptions, {
                    title: options,
                    icon: icon,
                    modalClass: modalClass,
                    buttons: buttons
                });
            }

            // initialize and open the dialog
            var dialog = new ModalView(dialogOptions);
            dialog.setBody(view);
            this.showPopup(dialog);

            return dialog;
        },

        /**
         * Inspect the view for dialog configuration options.  Newer views should supply
         * functions that return dialog configuration options.  Older views will use a standard set of attributes.
         * We need to support both modes for the time being.
         */
        getDialogOptions: function(view) {
            var dialogTitle = util.isFunction(view.dialogTitle) ? view.dialogTitle() : view.dialogTitle;
            return {
                type: 'custom',
                message: locale.get('loading'),
                title: util.isFunction(view.getHeader) ? view.getHeader() : dialogTitle,
                icon: util.isFunction(view.getHeaderIcon) ? view.getHeaderIcon() : view.dialogTitleIcon,
                modalClass: util.isFunction(view.getClass) ? view.getClass() : view.modalClass,
                buttons: util.isFunction(view.getButtons) ? view.getButtons() : bindDialogButtons(view)
            };
        },

        custom: function(viewInstance) {
            this.showPopup(viewInstance);
        },

        visible: function() {
            return $('body').hasClass('modal-open');
        },

        close: function() {
            if (this.activeModal) {
                this.activeModal.close();
                if (this.$dialogTrigger) {
                    this.$dialogTrigger.focus();
                    this.$dialogTrigger = null;
                }
            }
        },

        notify: function(message, type, duration) {
            var notification = new NotificationView({
                message: message,
                type: type,
                duration: duration
            });
            this.notifications.push(notification);

            notification.on('close', util.bind(this.removeNotification, this, notification));

            notification.render();

            this.resetNotifications();
        },

        resetNotifications: function() {
            var topOffset = this.notificationTopOffset;
            var spacing = this.notificationSpacing;
            util.each(this.notifications, function(notification) {
                notification.setTop(topOffset);
                var height = notification.height();
                topOffset += height + spacing;

            });
        },

        removeNotification: function(notification) {
            var index = this.notifications.indexOf(notification);
            //remove notifications from the list
            this.notifications.splice(index, 1);

            this.resetNotifications();
        }
    };
});

